import { z } from 'zod'

export const INPUT_FIELDS: AutoInfoInputFields[] = [
  'year',
  'mileage',
  'vin',
  'licensePlate',
]

export type AutoInfoInputFields = 'year' | 'mileage' | 'vin' | 'licensePlate'

export const DEFAULT_DATE = '1900-01-01'

export const FORMAT_PPP = 'PPP'

export const autoInfoFormSchema = z.object({
  carBrand: z.string().min(2, { message: 'Car brand is required.' }),
  carModel: z.string().min(1, { message: 'Car model is required.' }),
  year: z.string().min(4, { message: 'Enter a valid year.' }).max(4),
  mileage: z.string().optional(),
  distanceMetric: z.string().optional(),
  vin: z.string().optional(),
  engineType: z.string().optional(),
  licensePlate: z.string().min(1, { message: 'License late is required.' }),
  lastServiceDate: z.date().optional(),
  nextMaintenance: z.date().optional(),
  isMainCar: z.boolean().optional(),
})
